<template>
    <v-container class="'text-left">
        <v-btn x-small :color="taxStatusColor" dark class="ml-n3 pa-1" @click="showDialog">
            {{ localTaxStatus }}
        </v-btn>
        <v-row justify="center">
            <v-dialog
                    persistent
                    v-model="dialog"
                    max-width="290"
                    @keydown.esc="dialog = false"
                    @keydown.enter="toggleTaxStatus"
                    @keydown.space="toggleTaxStatus"
            >
                <v-card>
                    <v-card-title class="headline">세금계산 상태 변경</v-card-title>
                    <v-card-text>
                        상태를 변경하시겠습니까?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="dialog = false"
                        >취소</v-btn>

                        <v-btn
                                color="green darken-1"
                                text
                                @click="toggleTaxStatus"
                        >변경</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'TaxStatusButton',
        props: {
            orderId: {},
            taxStatus: {},
            disable: {}
        },
        data() {
            return {
                localTaxStatus: this.taxStatus,
                taxStatusColor: 'primary',
                dialog: false
            }
        },
        methods: {
            showDialog(event) {
                if(this.disable == true){
                    return false
                }
                event.preventDefault()
                this.dialog = true
            },
            toggleTaxStatus(event) {

                if(this.disable == true){
                    return false
                }

                event.preventDefault()
                this.dialog = false

                if(!this.orderId){
                    alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                    return false
                }

                return axios({
                    method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: this.$store.getters.getApiUrl + '/api/v1/order/toggleTaxStatus/' + this.orderId,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                    .then(response => {

                        if(response.data && response.data.taxStatus != ''){

                            this.localTaxStatus = response.data.taxStatus
                            this.changeButtonColor()

                        }

                    })

            },
            changeButtonColor() {

                switch(this.localTaxStatus){

                    case '미발행':
                        this.taxStatusColor = 'pink'
                        break

                    case '완료':
                        this.taxStatusColor = 'green'
                        break

                    case '카드':
                        this.taxStatusColor = 'primary'
                        break

                    default:
                        this.taxStatusColor = 'pink'
                        break

                }

            }
        },
        created(){
            this.changeButtonColor()
        }
    }
</script>